import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Blocks every protected route for logged-out users.
 *
 * AuthService.userAuthenticated is set during APP_INITIALIZER (NgInitDataService
 * runs test_login before the first navigation resolves), on login/logout, and by
 * the 401 interceptor, so a synchronous check is reliable here. This guard is
 * what stops SPA navigations (e.g. browser Back after logout) from rendering
 * protected pages; PermissionGuard only handles feature permissions and fails
 * open by design.
 */
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(
    private _authService: AuthService,
    private _router: Router,
  ) {}

  canActivate(): boolean | UrlTree {
    return this.check();
  }

  canActivateChild(): boolean | UrlTree {
    return this.check();
  }

  private check(): boolean | UrlTree {
    if (this._authService.is_user_authenticated()) {
      return true;
    }
    return this._router.createUrlTree(['/auth/login']);
  }
}
